import { ListItemStatus } from 'dashboard/models/list-item';
import { StickerProps } from 'design-system/components/Sticker';

export const LIST_ITEM_STATUS_MAP: Record<ListItemStatus, StickerProps['variant']> = {
  [ListItemStatus.Pending]: 'caution',
  [ListItemStatus.Active]: 'success',
  [ListItemStatus.Archived]: 'caution',
};

export const LIST_ITEM_STATUS_LABEL_MAP: Record<ListItemStatus, string> = {
  [ListItemStatus.Pending]: 'Pending',
  [ListItemStatus.Active]: 'Active',
  [ListItemStatus.Archived]: 'Inactive',
};
